import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Users } from "lucide-react";
import { fdate } from "@/pages/portal/Dashboard";

export default function AdminUsuarios() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/users").then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-users-page">
      <h1 className="display text-3xl font-extrabold uppercase">Usuários</h1>
      <p className="mt-1 text-sm text-slate-500">Usuários com acesso à área administrativa.</p>

      <div className="mt-6 card-tactical rounded-md overflow-hidden">
        {!items ? (
          <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-600" /></div>
        ) : !items.length ? (
          <div className="py-16 text-center">
            <Users className="w-10 h-10 text-slate-700 mx-auto" strokeWidth={1.25} />
            <p className="mt-3 text-sm text-slate-500">Nenhum usuário.</p>
          </div>
        ) : (
          <table className="w-full text-sm" data-testid="users-table">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
                <th className="px-5 py-3.5 font-medium">Nome</th>
                <th className="px-5 py-3.5 font-medium">E-mail</th>
                <th className="px-5 py-3.5 font-medium">Perfil</th>
                <th className="px-5 py-3.5 font-medium">Desde</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/70">
              {items.map((u) => (
                <tr key={u.id} data-testid={`user-row-${u.id}`}>
                  <td className="px-5 py-3.5 text-slate-200">{u.name || "—"}</td>
                  <td className="px-5 py-3.5 text-slate-400">{u.email}</td>
                  <td className="px-5 py-3.5">
                    <span className={`text-[11px] font-semibold uppercase tracking-wider border rounded-sm px-2 py-0.5 ${
                      u.role === "admin" ? "bg-orange-500/10 text-orange-400 border-orange-800" : "bg-slate-700/40 text-slate-300 border-slate-600"
                    }`}>
                      {u.role === "admin" ? "Administrador" : "Cliente"}
                    </span>
                  </td>
                  <td className="px-5 py-3.5 text-slate-400">{fdate(u.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
